import { CampaignChannel } from '../types/campaigns'

export const SUPPORTED_CHANNELS: CampaignChannel[] = ['EMAIL', 'SMS']

export const CHANNEL_LABELS: Record<CampaignChannel, string> = {
  EMAIL: 'Email',
  WHATSAPP: 'WhatsApp',
  SMS: 'SMS',
  TELEGRAM: 'Telegram',
}

export const CHANNEL_ICONS: Record<CampaignChannel, string> = {
  EMAIL: '📧',
  WHATSAPP: '💬',
  SMS: '💬',
  TELEGRAM: '✈️',
}

export const CHANNEL_COLORS: Record<CampaignChannel, string> = {
  EMAIL: 'success',
  WHATSAPP: 'info',
  SMS: 'primary',
  TELEGRAM: 'warning',
}
